import DomainEnrollOptionFull from './components/DomainEnrollOptionFull';
import * as React from 'react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import store from './store/store';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { HMPlusBit } from 'owa-domain-connect';
var DomainEnrollOption = {
    key: 'domainenroll',
    titleStringKey: 'options_premiumSubOption_PersonalEmail',
    searchTermsStringKey: 'options_premiumSubOption_PersonalEmail',
    hideTitleInFullOptions: false,
    fullOptionFormSettings: {
        render: function () { return React.createElement(DomainEnrollOptionFull, null); },
        isDirty: function () { return false; },
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: function () { return true; },
    },
    isHidden: function () {
        return !isMailFeatureEnabled('auth-domainConnect') ||
            !isControlFeatureEnabled('auth-PremiumDashboardApril') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox ||
            (getUserConfiguration().SessionSettings.PremiumAccountOffers & HMPlusBit) == HMPlusBit ||
            store.isDomainCreated;
    },
};
export default DomainEnrollOption;
//# sourceMappingURL=DomainEnrollOption.js.map